import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import { Box } from "@mantine/core";

interface GenderChartProps {
  data: number[];
}

const GenderChart: React.FC<GenderChartProps> = ({ data }) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstance = useRef<Chart>();

  useEffect(() => {
    // Cleanup function
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [chartRef.current]);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      if (ctx) {
        // Destroy previous chart instance if exists
        if (chartInstance.current) {
          chartInstance.current.destroy();
        }

        chartInstance.current = new Chart(ctx, {
          type: "bar",
          data: {
            labels: ["EPIC", "Cerner", "Athena-Health","eClinicalWorks", "Others"],
            datasets: [
              {
                label: "EHR",
                backgroundColor: "#00A651",
                barPercentage: 0.6,
                categoryPercentage: 0.5,
                data,
                borderRadius: {
                  topLeft: 8,
                  topRight: 8,
                  bottomLeft: 0,
                  bottomRight: 0,
                },
              },
            ],
          },
          options: {
            scales: {
              x: {
                title: {
                  display: true,
                },
                grid: {
                  display: false,
                },
                ticks: {
                  maxRotation: 0,
                  padding: 40,
                },
              },
              y: {
                title: {
                  display: true,
                  text: "Number of patients",
                },
                grid: {
                  display: false,
                },
              },
            },
            plugins: {
              legend: {
                position: "bottom",
                labels: {
                  usePointStyle: false,
                },
              },
            },
          },
        });
      }
    }
  }, [chartRef.current, data]);

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <canvas
        ref={chartRef}
        style={{ width: "100%", height: "100%", maxHeight: "599.3px" }}
      ></canvas>
    </Box>
  );
};

export default GenderChart;
